import { API_BASE_URL } from "../../api/api";

const Row = ({ label, children }) => (
  <div className="ui-kv__row">
    <span className="ui-kv__label">{label}</span>
    <span className="ui-kv__value">{children}</span>
  </div>
);

export const CardUserInfo = ({ user }) => {
  const identityUrl = user.identityDocument
    ? `${API_BASE_URL}/product/countries-available/get-file/${user.identityDocument}`
    : null;
  const rutUrl = user.rutDocument
    ? `${API_BASE_URL}/product/countries-available/get-file/${user.rutDocument}`
    : null;
  const bankCertificate = user.bankCertificate
    ? `${API_BASE_URL}/product/countries-available/get-file/${user.bankCertificate}`
    : null;

  return (
    <div className="ui-card">
      <h3 style={{ margin: "0 0 16px", fontSize: 15, fontWeight: 700 }}>Cuenta</h3>
      <div className="ui-kv">
        <Row label="Rol">{user.role}</Row>
        <Row label="Estado">{user.status ? "Activo" : "Inactivo"}</Row>
        <Row label="Confirmado">{user.is_confirmed ? "Sí" : "No"}</Row>
        <Row label="Creado">{user.createdAt ? new Date(user.createdAt).toLocaleString() : "-"}</Row>
      </div>

      {(identityUrl || rutUrl || bankCertificate) && (
        <div style={{ marginTop: 16, paddingTop: 14, borderTop: "1px solid #F1F3F9" }}>
          <div style={{ fontSize: 12.5, fontWeight: 600, marginBottom: 8 }}>Documentos</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {identityUrl && (
              <a href={identityUrl} target="_blank" rel="noopener noreferrer" className="ui-back" style={{ margin: 0, border: "1px solid #E1E4F0", borderRadius: 8, padding: "7px 11px" }}>
                <i className="ri-download-2-line" /> Identidad
              </a>
            )}
            {rutUrl && (
              <a href={rutUrl} target="_blank" rel="noopener noreferrer" className="ui-back" style={{ margin: 0, border: "1px solid #E1E4F0", borderRadius: 8, padding: "7px 11px" }}>
                <i className="ri-download-2-line" /> RUT
              </a>
            )}
            {bankCertificate && (
              <a href={bankCertificate} target="_blank" rel="noopener noreferrer" className="ui-back" style={{ margin: 0, border: "1px solid #E1E4F0", borderRadius: 8, padding: "7px 11px" }}>
                <i className="ri-download-2-line" /> Certificado bancario
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
